import { RecentUser, User } from "./User.type";
import apiClient from "../../../shared/utils/apiClient";

const API_URL = "Users";


export const getUsers = async () => {
  try {
    const response = await apiClient.get<User[]>(API_URL);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error fetching users: ${error.message}`);
  }
};

export const getRecentUsers = async (recordCount: number) => {
  try {
    //const RECENT_PATIENT_API_URL = `http://localhost:99/settings-service/api/Users/get-recent-users?$select=id,patientId&$expand=PersonalDetails($select=firstName,lastName,dateOfBirth,bloodGroup,gender)&orderby=id desc&$top=${recordCount}`;
      //const RECENT_PATIENT_API_URL = `https://app.adptifyx.com/settings-service/api/Users/get-recent-users?$select=id,patientId&$expand=PersonalDetails($select=firstName,lastName,dateOfBirth,bloodGroup,gender)&orderby=id desc&$top=${recordCount}`;
      const RECENT_PATIENT_API_URL = `${API_URL}/get-recent-users?$select=id,patientId&$expand=PersonalDetails($select=firstName,lastName,dateOfBirth,bloodGroup,gender)&orderby=id desc&$top=${recordCount}`;
    const response = await apiClient.get<RecentUser[]>(`${RECENT_PATIENT_API_URL}`);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error fetching users: ${error.message}`);
  }
};


export const addUser = async (user: User) => {
  try {
    const response = await apiClient.post<User>(API_URL, user);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error adding user: ${error.message}`);
  }
};

export const updateUser = async (user: User) => {
  try {
    const response = await apiClient.put<User>(`${API_URL}/${user.id}`, user);
    return response.data;
  } catch (error: any) {
    throw new Error(`Error updating user: ${error.message}`);
  }
};

export const deleteUser = async (userId: number) => {
  try {
    await apiClient.delete(`${API_URL}/${userId}`);
  } catch (error: any) {
    throw new Error(`Error deleting user: ${error.message}`);
  }
};
